import { render } from "./FooterPanel.vue?vue&type=template&id=478d5268"
import script from "./FooterPanel.vue?vue&type=script&lang=js"
export * from "./FooterPanel.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__